<template>
    <div class="gibs-grid-body">
        <div class="gibs-grid-container">
            <div class="gibs-grid-full-width">
                <div class="gibs-social-button-container">
                    <a class="w-[24px] h-[24px] cursor-pointer object-cover" 
                    v-on:click="useFacebook()" >       
                        <nuxt-icon name="social-media/fb-logo" class="text-3xl"/>          
                    </a>
                    <a class="w-[24px] h-[24px] cursor-pointer object-cover" 
                    v-on:click="useLinkedIn()" >
                        <nuxt-icon name="social-media/linkedin-logo" class="text-3xl"/>          
                    </a>
                    <a class="w-[24px] h-[24px] cursor-pointer object-cover" 
                    v-on:click="useTwitter()" >       
                        <nuxt-icon name="social-media/x-logo" class="text-3xl"/>          
                    </a>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

    const route = useRoute();
    const url = useRequestURL();
    let origin: String = '';
    let params: String = '';

    function useTwitter() {
        origin = url.origin;
        params = encodeURIComponent(`${origin}/${route.fullPath}`);
        const twitterURL = `https://twitter.com/intent/post?url=${params}&text=`;
        window.open(twitterURL, 'targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=350,height=450"');
    }

    function useFacebook() {
        origin = url.origin;
        params = encodeURIComponent(`${origin}/${route.fullPath}`);
        const facebookURL = `https://www.facebook.com/sharer.php?u=${params}`;
        window.open(facebookURL, 'targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=350,height=450"');
    }

    function useLinkedIn() {
        origin = url.origin;
        params = encodeURIComponent(`${origin}/${route.fullPath}`);
        const linkedinURL = `https://www.linkedin.com/sharing/share-offsite/?url=${params}`;
        window.open(linkedinURL, 'targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=350,height=450"');
    }

</script>